import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Mail, Phone } from 'lucide-react';

export const LeadershipCTA = () => (
  <section className="py-24 bg-[#0f172a]" data-testid="leadership-cta">
    <div className="max-w-7xl mx-auto px-6 lg:px-8 text-center">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
      >
        <h2 className="font-heading text-3xl sm:text-4xl font-semibold text-white mb-4">
          Ready to Work with Our Experts?
        </h2>
        <p className="text-slate-400 max-w-2xl mx-auto mb-8">
          Schedule a consultation and let our experienced team guide you through 
          your financial journey.
        </p>
        <div className="flex flex-wrap justify-center gap-4">
          <Link
            to="/contact"
            data-testid="leadership-contact-btn"
            className="gradient-btn px-8 py-4 rounded-full font-medium text-white inline-flex items-center gap-2"
          >
            <Mail size={18} />
            Contact Us
          </Link>
          <a
            href="tel:+919828092250"
            className="px-8 py-4 border-2 border-white/30 text-white rounded-full font-medium hover:bg-white/10 transition-colors inline-flex items-center gap-2"
          >
            <Phone size={18} />
            +91-77910-93252
          </a>
        </div>
      </motion.div>
    </div>
  </section>
);
